export default "__VITE_ASSET__BkVzkhOW__"